import { render, staticRenderFns } from "./RelatorioTermoFormulario.vue?vue&type=template&id=7d963a12"
import script from "./RelatorioTermoFormulario.vue?vue&type=script&lang=js"
export * from "./RelatorioTermoFormulario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports